module.exports = __webpack_public_path__ + "static/media/Best In Class Polygon Chamfering Wows the Crowd.9241b9be.png";